import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const CATEGORIES_CATEGORY_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/categories',
        name: '::Menu:Categories',
        iconClass: 'fas fa-folder',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Categories',
        parentName: '::Menu:Configurations',
        order: 3,
      },
    ]);
  };
}
